const SEVEN_DAYS_MS = 7 * 24 * 60 * 60 * 1000;

export type QualifiesForRobinVerifiedParams = {
  robinVerified: boolean | undefined;
  verifiedAtIso: string | undefined;
  now?: number;
};

export function parseRobinVerifiedAt(verifiedAtIso: string): number {
  let s = verifiedAtIso;
  if (typeof s === 'string' && s.includes('T') && !s.includes('Z') && !s.includes('+')) {
    s = `${s}Z`;
  }
  return Date.parse(s);
}

export function qualifiesForRobinVerified({
  robinVerified,
  verifiedAtIso,
  now = Date.now(),
}: QualifiesForRobinVerifiedParams): boolean {
  if (robinVerified === false || !verifiedAtIso) return false;

  const verifiedMs = parseRobinVerifiedAt(verifiedAtIso);
  if (Number.isNaN(verifiedMs)) return false;

  if (verifiedMs > now) return false;

  return now - verifiedMs <= SEVEN_DAYS_MS;
}
